export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'https://epaapi.apphub.co.in';
 //process.env.REACT_APP_API_BASE_URL || 'https://localhost:7121';

export const COMPANY_NAME =
  process.env.REACT_APP_COMPANY_NAME || 'EPA';

